import React, { useState } from "react";
import "../styles/admin.scss";
import Grid from "@mui/material/Grid2";
import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import instance, { updatedToken } from "../../Utils/api";
import { toast } from "react-toastify";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Login = ({ setTriggerRefresh }) => {
  console.log("Dffdsfdsf")
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    let isValid = true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email && !password) {
      setErrors({
        ...errors,
        email: "Email is required",
        password: "Password is required",
      });
      isValid = false;
    } else if (!email) {
      setErrors({ ...errors, email: "Email is required" });
      isValid = false;
    } else if (!emailRegex.test(email?.toString().trim())) {
      setErrors({ ...errors, email: "Invalid email format" });
      isValid = false;
    } else if (!password) {
      setErrors({ ...errors, password: "password is required" });
      isValid = false;
    } else {
      setErrors("");
    }
    return isValid;
  };

  const adminLogin = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true)
      const response = await instance.post("/Admin/login", {
        email,
        password,
      },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("id", response.data.id);
        updatedToken(response.data.token);
        const role = response.data.role;
        // window.location.href("/admin/dashboard");
        navigate("/admin/dashboard");
        setTriggerRefresh(true)
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false)
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      adminLogin();
    }
  };

  //  console.log("trail")
  return (
    <React.Fragment>
      <section className="admin-login-container">
        <div className="login-img">
          <div className="login-bgd"></div>
        </div>
        <div className="login-fields">
          <Grid
            container
            direction="column"
            spacing={2}
            className="login-fields-container"
          >
            <div className="login-header">
              <Typography variant="h5">
                Welcome to <span className="sub-heading">Tailors4U</span>
              </Typography>
              <Typography>
                To access your account, please enter your credentials
              </Typography>
            </div>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="login-textfiled">
                <TextField
                  type="email"
                  label="Email"
                  placeholder="Enter your email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors({ ...errors, email: "" });
                  }}
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email}
                  required
                />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="login-textfiled">
                <TextField
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  placeholder="Enter your password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors({ ...errors, password: "" });
                  }}
                  fullWidth
                  required
                  error={!!errors.password}
                  helperText={errors.password}
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          sx={{ backgroundColor: "white" }}
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>
            <div className="login-checkbox">
              <Typography
                variant="h5"
                onClick={() => navigate("/admin/forgotPassword")}
              >
                Forgot Password
              </Typography>
            </div>
            <Button variant="outlined" onClick={adminLogin} disabled={loading}>
              {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Login"} 
            </Button>
          </Grid>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Login;
